export default __webpack_public_path__ + "static/media/mr.6d5d216f.svg";